
export const API_URL = 'https://func-aden-eds-pre.azurewebsites.net/api/';
// export const API_URL = 'https://panelklientaapi.egurrola.com/api/';
 export const API_URL_getCourseWWWInfoPortal = 'https://web-aden-eds-web-pre.azurewebsites.net/API/CoursesHeadings/';

//export const API_URL_getCourseWWWInfoPortal ='https://panelklientaapi.egurrola.com/api/'